import { useEffect } from 'react'
import { triggerAppChange } from 'single-spa'

import { hasAnyRole } from '../auth/roles'
import NotFoundPage from '../components/NotFoundPage'
import { useUserRoles } from '../hooks/useUserRoles'

interface RoleRouteProps {
  roles: string[]
  children: React.ReactNode
}

// Wrap a route that only some roles may open; everyone else gets the not-found page
export const RoleRoute = ({ roles, children }: RoleRouteProps) => {
  const { roles: userRoles, isLoading } = useUserRoles()
  const isAllowed = hasAnyRole(userRoles, roles)

  // single-spa may have evaluated activeWhen before the token was stored, so re-check once access is known
  useEffect(() => {
    if (!isLoading && isAllowed) triggerAppChange()
  }, [isLoading, isAllowed])

  if (isLoading) return null
  if (!isAllowed) return <NotFoundPage />

  return <>{children}</>
}
